var productForm = $("#addToCartForm");
var addToCart = $("#addToCartButton");
var ready_to_submit = true;

$(function () {

  /*
  *   Update related products button based
  *   on browser history
  */
  (function () {
    var related_button = $("#addToCart").find(".related-products-btn");

    if ( Shopify.history.last_collection_page() && Shopify.history.last_collection_page().match("equipment-by-vehicle") ) {
      var model = sessionStorage.getItem("rcr_model_tag") || "vehicle";
      var breadcrumb_text = sessionStorage.getItem("rcr_model_tag") || "Equipment by Vehicle";
      var breadcrumb = $("#collection-breadcrumb");

      related_button
        .addClass("btn-text-compact")
        .attr("href", Shopify.history.last_collection_page())
        .find("span")
        .html("More recommendations for your " + model);

      breadcrumb
        .attr("href", Shopify.history.last_collection_page())
        .html(breadcrumb_text);
    }
  })();

  /*
  *   Mobile swipe gallery
  */
  var swiper = new Swiper(".swiper-container", {
    mode: "horizontal",
    loop: false,
    pagination: '.swiper-pagination',
    grabCursor: true,
    onInit: function () {
      if ( swiper.paginationButtons.length == 1 ) {
        $(swiper.paginationContainer).hide();
      }
    }
  });

  /*
  *   Fancybox gallery with next/prev
  */
  $("[rel=photo-gallery]").fancybox();

  /*
  *   Add to Cart
  */
  addToCart.click(function (e) {
    e.preventDefault();

    if ( productForm.is("[data-ready-to-submit=true]") ) {
      productForm.trigger("submit");
    } else {
      ready_to_submit = false;
      var first_unselected_option = productForm.find("select[data-valid=false]").eq(0).parents(".dropdown");
      first_unselected_option.toggleClass("animated shake");
      setTimeout(function () {
        first_unselected_option.toggleClass("animated shake");
        ready_to_submit = true;
      }, 850);
    }
  });

  productForm.bind("submit", function(e) {
    e.preventDefault();

    productForm.find(".add-to-cart").addClass("loading");

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function(lineItem) {
        updateMiniCart(lineItem);
      },
      error: function(XMLHttpRequest, textStatus) {
        var error = $.parseJSON(XMLHttpRequest.responseText);
        // alert(error.message + ": " + error.description);
        alert(error.description);
      }
    });

    function updateMiniCart(lineItem) {
      $.getJSON("/cart.js", function(cart, textStatus) {
        $("#cartCost").html(dollarFormat(cart.total_price));
        $("#cartCount").html(cart.item_count);

        productForm.find(".add-to-cart")
          .removeClass("loading")
          .addClass("in-cart");
      });
    }

    function dollarFormat(cents) {
      if (typeof cents == 'string') cents = cents.replace('.','');
      function addCommas(moneyString) {
        return moneyString.replace(/(\d+)(\d{3}[\.,]?)/,'$1,$2');
      }
      function floatToString(numeric, decimals) {
        var amount = numeric.toFixed(decimals).toString();
        if(amount.match(/^\.\d+/)) {return "0"+amount; }
        else { return amount; }
      }
      return "$" + addCommas(floatToString(cents/100.0, 2));
    }
  });
});

// ---------------------------------------------------------------------------
// linkOptionSelectors
// (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
// ---------------------------------------------------------------------------

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function (selectorIndex) {

  if ( $(".single-option-selector").eq(selectorIndex).length == 0 ) {
    return;
  }

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $('.single-option-selector:eq(0)');
      break;
    case 1:
      var key = $('.single-option-selector:eq(0)').val();
      var selector = $('.single-option-selector:eq(1)');
      break;
    case 2:
      var key = $('.single-option-selector:eq(0)').val();
      key += ' / ' + $('.single-option-selector:eq(1)').val();
      var selector = $('.single-option-selector:eq(2)');
  }

  var options = Shopify.optionsMap[key];

  selector.easyDropDown("enable").easyDropDown("destroy");
  selector.find("option").not(".label").remove();

  if ( options ) {
    _.each(options, function (option) {
      var new_option = $('<option></option>').val(option.name).html(option.name).prop("disabled", option.disabled);
      selector.append(new_option);
    });
  }

  selector.attr("data-valid", false);
  productForm.attr("data-ready-to-submit", false);

  Shopify.linkOptionsInitialize(selector);
};

Shopify.linkOptionsInitialize = function (selector) {
  var selectorIndex = $(".single-option-selector").index(selector);
  selector.easyDropDown({
    cutOff: 6,
    onChange: function (selector_object) {
      $(this).attr("data-valid", true);

      $(".add-to-cart").removeClass("in-cart");

      _.each($(".single-option-selector"), function (select_options, index) {
        if ( index > selectorIndex ) {
          Shopify.updateOptionsInSelector(index);
        }
      });

      if ( !$(".single-option-selector[data-valid=false]").length ) {
        productForm.attr("data-ready-to-submit", true);
      }

      $(".single-option-selector").eq(selectorIndex + 2).easyDropDown("disable");
    }
  });
}

Shopify.linkOptionSelectors = function (product) {

  _.each(product.variants, function(variant) {

    // Gathering values for the 1st drop-down.
    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
    Shopify.optionsMap['root'].push({ name: variant.option1, disabled: !variant.available });

    // Gathering values for the 2nd drop-down.
    if ( product.options.length > 1 ) {
      var key = variant.option1;
      Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
      Shopify.optionsMap[key].push({ name: variant.option2, disabled: !variant.available });
    }

    // Gathering values for the 3rd drop-down.
    if ( product.options.length === 3 ) {
      var key = variant.option1 + ' / ' + variant.option2;
      Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
      Shopify.optionsMap[key].push({ name: variant.option3, disabled: !variant.available });
    }
  });

  // Remove duplicate options
  _.forOwn(Shopify.optionsMap, function (options, key) {
    var uniq_names = [];
    var uniq_options = [];

    _.each(options, function (option, index) {
      if ( !_.contains(uniq_names, option.name) ) {
        uniq_names.push(option.name);
        uniq_options.push({ name: option.name, disabled: true }); // assume disabled
      }

      // not disabled if at least one available
      if ( !option.disabled ) {
        _.each(uniq_options, function (opt) {
          if ( opt.name == option.name ) {
            opt.disabled = false;
          }
        });
      }
    });

    Shopify.optionsMap[key] = uniq_options;
  });

  // Initialize selection dropdowns
  _.each($(".single-option-selector"), function (selector, index) {
    Shopify.linkOptionsInitialize($(selector));
  });

  $(".single-option-selector").not(":eq(0)").easyDropDown("disable");
};
